import * as React from 'react'
import { SVGComponentProps } from '../type'

const ReceiptEditIcon = (props: SVGComponentProps) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.90564 16.455C7.73314 16.455 7.56814 16.38 7.45564 16.23L6.69813 15.2175C6.54063 15.0075 6.33064 14.8875 6.10564 14.8725C5.87314 14.8575 5.65562 14.9625 5.47562 15.15C4.38812 16.3125 3.56313 16.215 3.16563 16.065C2.76063 15.9075 2.07812 15.39 2.07812 13.725V5.28001C2.07812 1.95001 3.03813 0.9375 6.18063 0.9375H11.8431C14.9856 0.9375 15.9456 1.95001 15.9456 5.28001V8.47499C15.9456 8.78249 15.6906 9.03749 15.3831 9.03749C15.0756 9.03749 14.8206 8.78249 14.8206 8.47499V5.28001C14.8206 2.57251 14.3481 2.0625 11.8431 2.0625H6.18063C3.67563 2.0625 3.20312 2.57251 3.20312 5.28001V13.725C3.20312 14.5125 3.39813 14.9475 3.57812 15.015C3.71312 15.0675 4.08064 14.9925 4.65064 14.385C5.06314 13.95 5.60313 13.7175 6.16563 13.7475C6.72063 13.7775 7.24564 14.07 7.59814 14.5425L8.36313 15.555C8.55063 15.8025 8.49813 16.155 8.25063 16.3425C8.13813 16.425 8.01814 16.455 7.90564 16.455Z"
      fill={props.fill}
    />
    <path
      d="M12 5.8125H6C5.6925 5.8125 5.4375 5.5575 5.4375 5.25C5.4375 4.9425 5.6925 4.6875 6 4.6875H12C12.3075 4.6875 12.5625 4.9425 12.5625 5.25C12.5625 5.5575 12.3075 5.8125 12 5.8125Z"
      fill={props.fill}
    />
    <path
      d="M11.25 8.8125H6.75C6.4425 8.8125 6.1875 8.5575 6.1875 8.25C6.1875 7.9425 6.4425 7.6875 6.75 7.6875H11.25C11.5575 7.6875 11.8125 7.9425 11.8125 8.25C11.8125 8.5575 11.5575 8.8125 11.25 8.8125Z"
      fill={props.fill}
    />
    <path
      d="M11.1186 16.335C10.8336 16.335 10.5636 16.23 10.3686 16.035C10.1361 15.8025 10.0311 15.465 10.0836 15.1125L10.2261 14.0999C10.2636 13.8374 10.4211 13.5225 10.6086 13.335L13.2636 10.68C13.6236 10.32 13.9761 10.1325 14.3586 10.095C14.8236 10.05 15.2886 10.245 15.7236 10.68C16.1586 11.115 16.3536 11.5725 16.3086 12.045C16.2711 12.42 16.0761 12.7799 15.7236 13.1399L13.0686 15.795C12.8811 15.9825 12.5661 16.14 12.3036 16.1775L11.2911 16.32C11.2311 16.3275 11.1786 16.335 11.1186 16.335ZM14.4861 11.2125C14.4786 11.2125 14.4711 11.2125 14.4636 11.2125C14.3586 11.22 14.2161 11.3174 14.0586 11.4749L11.4036 14.13C11.3811 14.1525 11.3436 14.2275 11.3436 14.2575L11.2086 15.195L12.1461 15.0599C12.1761 15.0524 12.2511 15.015 12.2736 14.9925L14.9286 12.3375C15.0861 12.1725 15.1836 12.0375 15.1911 11.9325C15.2061 11.7825 15.0561 11.6024 14.9286 11.4749C14.8086 11.3549 14.6361 11.2125 14.4861 11.2125Z"
      fill={props.fill}
    />
    <path
      d="M14.9365 13.6874C14.884 13.6874 14.8315 13.6799 14.7865 13.6649C13.7965 13.3874 13.009 12.6 12.7315 11.61C12.649 11.31 12.8215 11.0024 13.1215 10.9124C13.4215 10.8299 13.729 11.0025 13.8115 11.3025C13.984 11.9175 14.4715 12.4049 15.0865 12.5774C15.3865 12.6599 15.559 12.975 15.4765 13.275C15.409 13.5225 15.184 13.6874 14.9365 13.6874Z"
      fill={props.fill}
    />
  </svg>
)

ReceiptEditIcon.defaultProps = {
  width: 18,
  height: 18,
  fill: '#64748B'
}

export { ReceiptEditIcon }
